// # #############################################
// # Title : Warning Dialogue
// # Authors : Dhruv
// # Date : 15th October 2019
// # Last Modified : Dhruv, September 2019
// # Version : 19.10.03
// # Description : This is the code for rendering a warning dialogue ( Reusable component )
// # ############################################


import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class WarningDialogue extends Component {
    state = {

    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.props.handleCloseWarning}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {this.props.body}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleAction2} color="primary">
                        {this.props.action2}
                    </Button>
                    <Button onClick={this.props.handleCloseWarning} color="primary">
                        {this.props.action1}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default WarningDialogue;